import { useTranslation } from 'next-i18next';
import { DSButton, DSDialog, DSHeading } from '@stihl-design-system/components';

export const DeleteConfirmationDialog = ({ isOpen, onClose, onConfirm, filename }) => {
  const { t } = useTranslation('shared');

  return (
    <DSDialog
      isOpen={isOpen}
      onClose={onClose}
      aria-label={`${t('shared_imageUpload_button_delete')} (${filename})`}
      header={
        <DSHeading tag="h3" className="stihl-text-h3-desktop">
          {t('shared_imageUpload_button_delete')}
        </DSHeading>
      }
      footer={
        <div className="flex gap-x-4">
          <DSButton
            type="button"
            onClick={onConfirm}
            data-testid="confirmDelete"
            aria-label={`${t('shared_deleteImageConfirmation_button_aria')} (${filename})`}
          >
            {t('shared_confirm_button')}
          </DSButton>
          <DSButton type="button" variant="outline" onClick={onClose} data-testid="cancelDelete">
            {t('shared_cancel_button')}
          </DSButton>
        </div>
      }
      data-testid="delete-confirmation-modal"
    >
      <span className="block stihl-text-body-default-reg">{t('shared_deleteImageConfirmation_text')}</span>
    </DSDialog>
  );
};
